/**
 * Pure helpers for the manual-charge form. Kept out of the component so the loading-gate
 * behavior can be unit-tested without rendering the whole form (staff-fe has no MockedProvider
 * component-test pattern). (#34093)
 */

export const PAYMENT_METHODS_LOADING_HELPER_TEXT = 'Loading payment methods…';

/**
 * Props for the Payment Method `Field` while the agency sweep account is still loading — a
 * no-cache `getSweepAccount` query that re-fires on every page open, so its methods land after
 * the initial render. Disables the field so it can't be opened before its options resolve, and
 * includes the "Loading…" helper text ONLY while loading: spreading `helperText` unconditionally
 * would override the select's own validation-error text, so the key is omitted when not loading.
 */
export const paymentMethodFieldLoadingProps = (loading) =>
  loading ? { disabled: true, helperText: PAYMENT_METHODS_LOADING_HELPER_TEXT } : { disabled: false };

/**
 * What paying the term off costs now (#37632): premium + fees + surplus − received, less the installment
 * fees of installments that will no longer run (billing's `installmentFeePayoffWaiver`; a payoff carries
 * no installment fee). The waiver is 0 on an installment line written before #37632, so that balance is
 * exactly what it always was.
 */
export const remainingBalance = ({ billingDetails, totalPrice, totalReceived }) => {
  const waiver = Number(billingDetails?.installmentFeePayoffWaiver);
  const balance = totalPrice - totalReceived;
  if (!(waiver > 0)) {
    return balance;
  }
  return Math.round((balance - waiver) * 100) / 100;
};
